<div class="RadioButton" [formGroup]="group">
  <ion-label
    class="radio-label-padding"
    [innerHTML]="field.label + ':'"
  ></ion-label>
  <ion-radio-group
    class="RadioButton__RadioGroup"
    [formControlName]="field.name"
  >
    @for (fieldOption of getFieldOptions(field); track fieldOption) {
      <ion-radio
        class="RadioButton__Radio"
        [value]="fieldOption"
        labelPlacement="end"
        >{{ fieldOption }}
      </ion-radio>
    }
  </ion-radio-group>
</div>
